import {createContext} from "react";

export const LoginContext = createContext({
    loginDetails: null,
    setLoginDetails: (val) => {}
})